import React, { useEffect } from 'react';
import { convertFieldsToGraphqlVariables } from '../../graphql-helpers';
import { Campaign,  useCampaignsQueryQuery } from "../../generated/graphql";
import { useToast } from "../../contexts/toast";
import {useLocation} from "react-router";
import QueryString from "query-string";
import { useFieldTableExport } from '../../components/FieldTable/FieldTableExport';
import { FieldTableColumnProps } from '../../components/FieldTable/FieldTableTypes';

type QSP = {
    name:string,
    type:string,
    value:any
};

const columns:Array<FieldTableColumnProps<Campaign>> = [
    {
        accessor: 'campaign.job_reference',
        header: 'Job Ref',
        dataType:'text'
    }, {
        accessor: 'sundry.sundryType.name',
        header: 'Name',
        dataType:'text'
    }, {
        accessor: 'sundry.name',
        header: 'Supplier Name',
        dataType:'text'
    }, {
        accessor: 'sundry.notes',
        header: 'Supplier Notes',
        dataType:'text'
    }, {
        accessor: 'sundry.campaignComponent.regionType.name',
        header: 'RegionType',
        dataType:'text'
    }, {
        accessor: 'sundry.campaignComponent.region.name',
        header: 'Region',
        dataType:'text'
    }, {
        accessor: 'sundry.date_up',
        header: 'Date Up',
        dataType:'date'
    }, {
        accessor: 'sundry.date_up',
        header: 'Date Up',
        dataType:'date'
    }, {
        accessor: 'sundry.date_down',
        header: 'Date Down',
        dataType:'date'
    }, {
        accessor: 'sundry.use_global_discount',
        header: 'Use Global Discount',
        dataType: 'boolean'
    }, {
        accessor: 'sundry.campaignComponent.qty',
        header: 'Qty',
        dataType: 'number'
    }, {
        accessor: 'sundry.campaignComponent.unit_value_local',
        header: 'Value',
        dataType: 'currency'
    }, {
        accessor: 'campaign.currency.label',
        header: 'Quote Currency',
        dataType: 'text'
    }
];


export const SundriesReport = ({ params, done }: { params?: any, done: () => void }) => {
    const location = useLocation();
    const rawParsedQueryString = QueryString.parse(location.search);
    const queryStringArray:QSP[] = [];
    Object.entries(rawParsedQueryString).forEach(function ([k, v]) {
        const name = k.split('-');
        queryStringArray.push({name: name[0], type: name[1], value: v});
    });
    const gqlParams = convertFieldsToGraphqlVariables(queryStringArray);
    gqlParams.with_costs = false;
    gqlParams.with_sundries = true;
    const { toast, dismiss } = useToast();
    toast('Generating report', { id: 'GEN_REPORT', timeout: 0 });
    const query = useCampaignsQueryQuery({
        //useQuery(campaignsQuery,{
        variables: gqlParams,
        fetchPolicy: "network-only",
        onError: () => {
            toast('Error generating report', { id: 'GEN_REPORT', variant: 'error' });
            done();
        }
    });
    const {exportData} = useFieldTableExport({
        columns:columns,
        name:'sundries-report',
        values:query?.data?.campaigns?.data
    });
    useEffect(()=>{
        if(!query.data) return;
        if(exportData) {
            const parsedData = [];
            // the result is an array of campaigns containing arrays of sundries
            // flatten into [{campaign,sundry}]
            query.data?.campaigns?.data.forEach((campaign)=>{
                if(!campaign?.sundries?.length) return;
                campaign?.sundries?.forEach((sundry)=>{
                    parsedData.push({campaign:campaign,sundry:sundry});
                });
            })
            exportData(parsedData);
        }
        done();
    },[query?.data,exportData]);
    return <></>;
}